import { client } from '~/api/client';
import { mutateData } from '~/api/data/request';
import {
  MarkCaraWorkspaceArtifactFinalDocument,
  MarkCaraWorkspaceArtifactFinalMutation,
  MarkCaraWorkspaceArtifactFinalMutationVariables,
  EnsureCaraWorkspaceArtifactFitsDesignDocument,
  EnsureCaraWorkspaceArtifactFitsDesignMutation,
  EnsureCaraWorkspaceArtifactFitsDesignMutationVariables,
  SetCaraWorkspaceArtifactDesignDocument,
  SetCaraWorkspaceArtifactDesignMutation,
  SetCaraWorkspaceArtifactDesignMutationVariables,
  UnmarkCaraWorkspaceArtifactFinalDocument,
  UnmarkCaraWorkspaceArtifactFinalMutation,
  UnmarkCaraWorkspaceArtifactFinalMutationVariables
} from '~/api/graphql';

export const setCaraWorkspaceArtifactDesign = (
  variables: SetCaraWorkspaceArtifactDesignMutationVariables
) =>
  mutateData<
    SetCaraWorkspaceArtifactDesignMutation,
    SetCaraWorkspaceArtifactDesignMutationVariables
  >(client, { mutation: SetCaraWorkspaceArtifactDesignDocument, variables });

export const ensureCaraWorkspaceArtifactFitsDesign = (
  variables: EnsureCaraWorkspaceArtifactFitsDesignMutationVariables
) =>
  mutateData<
    EnsureCaraWorkspaceArtifactFitsDesignMutation,
    EnsureCaraWorkspaceArtifactFitsDesignMutationVariables
  >(client, { mutation: EnsureCaraWorkspaceArtifactFitsDesignDocument, variables });

export const markCaraWorkspaceArtifactFinal = (
  variables: MarkCaraWorkspaceArtifactFinalMutationVariables
) =>
  mutateData<
    MarkCaraWorkspaceArtifactFinalMutation,
    MarkCaraWorkspaceArtifactFinalMutationVariables
  >(client, { mutation: MarkCaraWorkspaceArtifactFinalDocument, variables });

export const unmarkCaraWorkspaceArtifactFinal = (
  variables: UnmarkCaraWorkspaceArtifactFinalMutationVariables
) =>
  mutateData<
    UnmarkCaraWorkspaceArtifactFinalMutation,
    UnmarkCaraWorkspaceArtifactFinalMutationVariables
  >(client, { mutation: UnmarkCaraWorkspaceArtifactFinalDocument, variables });
